var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.resourcePlanning.hasSelectedActivity)?_c('div',[_c('GenericForm',{attrs:{"model":_vm.formModel}}),_c('ToolkitButton',{attrs:{"action":_vm.saveButtonModel}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }